import { render } from "./SearchBarVue.vue?vue&type=template&id=3b362e09&scoped=true"
import script from "./SearchBarVue.vue?vue&type=script&lang=js"
export * from "./SearchBarVue.vue?vue&type=script&lang=js"

import "./SearchBarVue.vue?vue&type=style&index=0&id=3b362e09&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b362e09"]])

export default __exports__